import styled from 'styled-components';

import { breakpoints } from '@notino/react-styleguide-v20';

import { ImageWrapper } from '@sharedComponents/Images';

export const StyledImage = styled(ImageWrapper)`
  height: 3.75rem;
  max-width: 3.75rem;
  padding: 0 0.5rem;

  @media (min-width: ${breakpoints.md}) {
    margin-right: 1rem;
    padding: 0;
  }
`;
